// whatsapp.js — the single place that builds the prefilled WhatsApp links to Dilatih CS.
// Every text starts with a tag ([Perusahaan] | [Pribadi] | [Umum]) and ends with the page path,
// so chats can be attributed (see ops/chatwoot-contact-kind.py, ops/leads-sync.sh).

const WA_NUMBER = '6285174369965'

/** location.pathname only (no query/hash), max 80 chars; '/' when there is no window (prerender/SSR). */
export function pagePath() {
  if (typeof window === 'undefined' || !window.location) return '/'
  return (window.location.pathname || '/').slice(0, 80)
}

/** tag: 'Perusahaan' | 'Pribadi' | 'Umum' */
export function waUrl(tag, text) {
  return `https://wa.me/${WA_NUMBER}?text=` + encodeURIComponent(`[${tag}] ${text} (hal: ${pagePath()})`)
}
